import { defineStyleConfig } from '@chakra-ui/react'

const Heading = defineStyleConfig({
  sizes: {
    md: {
      fontSize: "16px",
      lineHeight: "28px",
      margin: "auto"
    },
    lg: {
      fontSize: "18px",
      lineHeight: "24px",
      margin: "auto"
    },
    xl: {
      fontSize: "22px",
      fontWeight: 500,
      lineHeight: "30px",
      margin: "auto"
    }
  },
  defaultProps: {
    size: "md",
  }
})
export default Heading